var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.length),function(index){return _c('div',{key:index,staticClass:"promo__list-item__loader"},[_c('div',{staticClass:"promo__list-item__loader__title"}),_c('div',{staticClass:"promo__list-item__loader__subtitle"})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }